// extracted by mini-css-extract-plugin
module.exports = {"sl2d7hw":"sl2d7hw","szj6560":"szj6560"};